import { Component, signal } from '@angular/core';
import { FSharedServiceService } from '../../../Services/FService/f-shared-service.service';
import { FServiceService } from '../../../Services/FService/f-service.service';
import { FormBuilder, Validators } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { CadService } from '../../../Services/CADServices/cad.service';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { environment } from '../../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-f-second-selection',
  templateUrl: './f-second-selection.component.html',
  styleUrl: './f-second-selection.component.css'
})
export class FSecondSelectionComponent {
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
constructor(private sharedDataService: SharedDataService,private formBuilder:FormBuilder,private fservice:FServiceService, private fSharedService:FSharedServiceService,private cadService:CadService,private router:Router){
  this.AssetbasePath = environment.assetsPath;
}
AssetbasePath:any;
formSubmitted = false;
  inputUnitVersion:any;
  inputTypeOfUnit:any;
  inputOutputShaft:any;
  inputBoreDia:any;
  inputMotorAdaptor:any;
  inputAssemblyPosition:any;
  inputPrimaryMountingPosition:any;
  inputSpecialFeature:any;
  productCode:any;
  productCode1:any;
  productCodeCAD:any;
  bore:any;
  finalData:any={
    location:"",
    code:""
  };
  CADfileFormat={
    CAD2DFileFormat:'.dxf',
    CAD3DFileFormat:'.stp',
  };
  reducerSelectionForm = this.formBuilder.group({
    inputUnitVersion:[null, Validators.required],
    inputType:[null, Validators.required],
    inputOutputShaft:[null, Validators.required],
    inputAssemblyPosition:[null,Validators.required],
    inputMotorAdaptor:[null,Validators.required],
    inputMountingPosition:[null,Validators.required],
    inputSpecialFeature:[null,Validators.required],
    inputBoreDia:[null,Validators.required],
  });
  assembleCode={
    series:"F0",
    size:"",
    revision:"1",
    ratio:"",
    untiversion:"",
    typeOfUnit:"",
    outputshaft:"",
    BoreDia:"",
    motorAdaptor:"",
    mountingPosition:"",
    primaryMountingPosition:"",
    specialfeature:"",
    UV:""
};
specData:any={};
size:any;
ratio:any;
speed:any;
public showspinfo: boolean = false;
public showcdinfo: boolean = false;
ngOnInit(){
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
  this.fSharedService.specification$.subscribe((specificationData:any) => 
    {
      this.specData= specificationData;
      console.log("F Series Data", this.specData);
    });
    this.fSharedService.size$.subscribe((sizeData:any) => 
      {
        // this.size = sizeData.size.replace(/[a-zA-Z]/g, '');
        console.log("Data of set size rato and speed at Series F", sizeData);
        this.size = sizeData.size;
        this.ratio = sizeData.ratio;
        this.speed = sizeData.speed;
        this.assembleCode.size = sizeData.size;
        this.assembleCode.ratio = sizeData.ratio;
        // this.assembleCode.inputspeed = sizeData.speed;
        this.getInputType();
      });
}
private getInputType():void{
  this.signalStatus=true;
  this.panelOpenState = signal(this.signalStatus);
  // const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  // rgImage.src = "./Powermate/assets/Content/FImages/InputType.jpg";
  this.fservice.getInputType().subscribe(result=>{
    this.inputTypeOfUnit = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
  },
  (error)=>{
    console.error('Error fetching in type of unit :', error);
  });
}
private getUnitVersion():void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/FImages/UnitVersion.jpg";
  this.fservice.getUnitVersion().subscribe(result=>{
     this.inputUnitVersion = Object.keys(result).map(key => ({
       key: key,
       value: result[key]
     }));
  },
 (error)=>{
   console.error('Error fetching in unitversion :', error);
 });
 }
 
private getOutputShaft(Size:any,UnitVersion:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/FImages/OutputShaft.jpg";
  this.fservice.getOutputShaft(Size,UnitVersion).subscribe(result=>{
    this.inputOutputShaft = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Output Shaft", result);
  },
  (error)=>{
    console.error('Error fetching in Output Shaft :', error);
  });
}
private getBoreDia(Size:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/FImages/OutputShaft.jpg";
  this.fservice.getBoreDia(Size).subscribe(result=>{
    this.inputBoreDia = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
  },
  (error)=>{
    console.error('Error fetching in Bore Diameter :', error);
  });
}
private getMotorAdaptor(typeOfUnit:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/FImages/MotorAdaptor.jpg";
  this.fservice.getMotorAdaptor(typeOfUnit).subscribe(result=>{
    this.inputMotorAdaptor = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Motor Adaptor", result);
  },
  (error)=>{
    console.error('Error fetching in Motor Adaptor :', error);
  });
}

private getAssemblyPosition(typeofunit:any,unitVersion:any,outputShaft:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/FImages/AssemblyPosition.jpg";
  this.fservice.getAssemblyPosition(typeofunit,unitVersion,outputShaft).subscribe(result=>{
    this.inputAssemblyPosition = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
  },
  (error)=>{
    console.error('Error fetching in assembly Position :', error);
  });
}
private getSpecialFeature(unitVersion:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  
  rgImage.src = this.AssetbasePath+"/Content/FImages/SpecialFeature.jpg";
  this.fservice.getSpecialFeature(unitVersion).subscribe(result=>{
    this.inputSpecialFeature = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
  },
  (error)=>{
    console.error('Error fetching in Special Features :', error);
  });
}

onTypeOfUnitChange(event:any){
  debugger;
  this.assembleCode.typeOfUnit = event.target.value;
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement;
  if(this.assembleCode.typeOfUnit == "R"){
    motorAdaptor.disabled = true;
    this.assembleCode.motorAdaptor = "-";
    this.resetDependentDropdowns(['inputMotorAdaptor']);
    this.reducerSelectionForm.get('inputMotorAdaptor')?.clearValidators();
  this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
  }else{
    if(motorAdaptor.disabled == true){
      motorAdaptor.disabled = false;
      this.assembleCode.motorAdaptor = "";
    }
  }
  this.getUnitVersion();
  this.resetDependentDropdowns(['inputUnitVersion']);
}
onUnitVersionChange(event:any){
  this.assembleCode.untiversion = event.target.value;
  if(this.assembleCode.untiversion=="TL" || this.assembleCode.untiversion=="TR"){
    this.assembleCode.UV = "T";
  }else{
    this.assembleCode.UV = this.assembleCode.untiversion;
  }
  this.getOutputShaft(this.size, this.assembleCode.UV);
  this.resetDependentDropdowns(['inputOutputShaft']);
}

oninputOutputShaftChange(event:any){
  debugger;
  this.assembleCode.outputshaft = event.target.value;
  const boreDia = document.getElementById("inputBoreDia") as HTMLInputElement;
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement;

  if(this.assembleCode.outputshaft=="-"){
    if(boreDia.disabled == true){
      boreDia.disabled = false;
    }
    
    this.getBoreDia(this.size);
    this.resetDependentDropdowns(['inputBoreDia']);
  }else{
    this.resetDependentDropdowns(['inputBoreDia']);
    this.reducerSelectionForm.get('inputBoreDia')?.clearValidators();
  this.reducerSelectionForm.get('inputBoreDia')?.updateValueAndValidity();
    if(this.assembleCode.typeOfUnit =="R"){
      motorAdaptor.disabled = true;
      this.reducerSelectionForm.get('inputMotorAdaptor')?.clearValidators();
  this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
    }else{
      motorAdaptor.disabled = false;
    }
    
    boreDia.disabled = true;
    this.bore=false;
    if(this.assembleCode.typeOfUnit == "R"){
      this.getAssemblyPosition(this.assembleCode.typeOfUnit,this.assembleCode.UV, this.assembleCode.outputshaft);
      this.resetDependentDropdowns(['inputAssemblyPosition']);
    }else{
      this.getMotorAdaptor(this.assembleCode.typeOfUnit);
      this.resetDependentDropdowns(['inputMotorAdaptor']);
    }
    
  }
}
oninputBoreDiaChange(event:any){
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement;
  // motorAdaptor.disabled = true;
  // this.reducerSelectionForm.get('inputMotorAdaptor')?.clearValidators();
  // this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
  this.assembleCode.BoreDia = event.target.value;
  // this.getAssemblyPosition(this.assembleCode.typeOfUnit,this.assembleCode.untiversion, this.assembleCode.BoreDia);
  // this.resetDependentDropdowns(['inputAssemblyPosition']);

  if(this.assembleCode.typeOfUnit == "R"){
    this.getAssemblyPosition(this.assembleCode.typeOfUnit,this.assembleCode.UV, this.assembleCode.BoreDia);
    this.resetDependentDropdowns(['inputAssemblyPosition']);
  }else{
    this.bore=true;
    this.getMotorAdaptor(this.assembleCode.typeOfUnit);
    this.resetDependentDropdowns(['inputMotorAdaptor']);
  }
}
oninputMotorAdaptorChange(event:any){
  debugger;
  this.assembleCode.motorAdaptor = event.target.value;
  if(this.bore==true){
    this.getAssemblyPosition(this.assembleCode.typeOfUnit,this.assembleCode.UV, this.assembleCode.BoreDia);
  }else{
    this.getAssemblyPosition(this.assembleCode.typeOfUnit,this.assembleCode.UV, this.assembleCode.outputshaft);
  }
  
  this.resetDependentDropdowns(['inputAssemblyPosition']);
}
oninputAssemblyPositionChange(event:any){
  debugger;
  this.assembleCode.mountingPosition = event.target.value;
  this.getSpecialFeature(this.assembleCode.UV);
  this.resetDependentDropdowns(['inputSpecialFeature']);
}
oninputSpecialFeatureChange(event:any){
  this.assembleCode.specialfeature = event.target.value;
   }


private resetDependentDropdowns(dropdownNames: string[]) {
  dropdownNames.forEach(name => {
    this.reducerSelectionForm.get(name)?.reset();
  });
}
rgReducerButton(){
  debugger;
  this.formSubmitted = true;
  if(this.assembleCode.BoreDia!=""){
    this.assembleCode.outputshaft = this.assembleCode.BoreDia;
  }
  // this.productCode = this.assembleCode.size + this.assembleCode.revision + this.assembleCode.ratio + this.assembleCode.typeOfUnit + this.assembleCode.untiversion  + this.assembleCode.outputshaft + this.assembleCode.motorAdaptor + this.assembleCode.mountingPosition + this.assembleCode.specialfeature; 
  this.productCode = this.assembleCode.size + this.assembleCode.revision + this.assembleCode.ratio + this.assembleCode.typeOfUnit + this.assembleCode.UV  + this.assembleCode.outputshaft + this.assembleCode.motorAdaptor + this.assembleCode.mountingPosition + this.assembleCode.specialfeature; 
  this.productCode1 = this.assembleCode.size + this.assembleCode.revision + this.assembleCode.ratio + this.assembleCode.typeOfUnit + this.assembleCode.UV  + this.assembleCode.outputshaft + this.assembleCode.motorAdaptor + this.assembleCode.mountingPosition + this.assembleCode.specialfeature+";"+this.assembleCode.untiversion; 
  console.log("Product Code FFFF is: ", this.productCode);
  this.fSharedService.setProductCode(this.productCode);
  this.sharedDataService.setCADChangeStatus("true");
  this.getAllproductDetail();
  // this.getKits();
  this.createCAD();
}
getAllproductDetail(){
  debugger;
  const unitversion = document.getElementById("inputUnitVersion") as HTMLSelectElement;
  const typeOfUnit = document.getElementById("inputType") as HTMLSelectElement;
  const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
  const assemblyPosition = document.getElementById("inputAssemblyPosition") as HTMLSelectElement;
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLSelectElement;
  const boreDia = document.getElementById("inputBoreDia") as HTMLSelectElement;
  const specialFeature = document.getElementById("inputSpecialFeature") as HTMLSelectElement;
  const prodDetails={
    size:this.assembleCode.size,
    ratio: this.assembleCode.ratio,
    unitversion: unitversion.options[unitversion.selectedIndex].text,
    unitversionValue:unitversion.value,
    typeOfUnit: typeOfUnit.options[typeOfUnit.selectedIndex].text,
    typeOfUnitValue: typeOfUnit.value,
    OutputShaft: OutputShaft.options[OutputShaft.selectedIndex].text,
    OutputShaftValue: OutputShaft.value,
    assemblyPosition: assemblyPosition.options[assemblyPosition.selectedIndex].text,
    assemblyPositionValue: assemblyPosition.value,
    boreDia: boreDia.options[boreDia.selectedIndex].text,
    boreDiaValue: boreDia.value,
    motorAdaptor: motorAdaptor.options[motorAdaptor.selectedIndex].text,
    motorAdaptorValue:motorAdaptor.value,
    
    specialFeature: specialFeature.options[specialFeature.selectedIndex].text,
    specialFeatureValue:specialFeature.value,
    // speed:this.assembleCode.inputspeed,
  };
  console.log("MY F PRODUCT DATA", prodDetails);
  this.fSharedService.setProductSpecification(prodDetails);
 }
createCAD():void {
    const cadData={
      Website:"Stainless",
      Guid: uuidv4(),
      Code:this.productCode1.toString().trim(),
      asmFormat:this.CADfileFormat.CAD3DFileFormat.toString().trim(),
      dwgFormat:this.CADfileFormat.CAD2DFileFormat.toString().trim(),
      MotorFrame: "",
      FlangType:"",
      ShaftDia:"",
      TimeIn:this.getCurrentFormattedDate(),
      ClientIP:"10.248.24.1"
    };
    // this.finalData.cadLocation = cadData.Guid;
    this.finalData.location = cadData.Guid;
    this.finalData.code = cadData.Code;
    this.fSharedService.setCadData(this.finalData);
    this.cadService.GenerateCADLoadbalancing(cadData);
  
    }
    getCurrentFormattedDate(): string {
      const now = new Date();
    
      // Helper function to pad single-digit numbers with leading zero
      const dateData = (num: number) => num.toString().padStart(2, '0');
    
      return `${now.getFullYear()}-${dateData(now.getMonth() + 1)}-${dateData(now.getDate())}T${dateData(now.getHours())}:${dateData(now.getMinutes())}:${dateData(now.getSeconds())}`;
    }
}
